{{combo-box
  class=this.fieldClass
  value=this.field.value
  content=this.field.content
  tabindex=this.field.tabindex
  onChange=(action "onChangeValue")
  options=(hash none="select_kit.default_header_text")
}}